(() => {
  const english = document.documentElement.lang.startsWith('en');
  document.querySelectorAll('.blx-hand-buy form, .blx-sales-cart form').forEach(form => {
    form.addEventListener('submit', async event => {
      const button = event.submitter;
      if (!button || !['add', 'update'].includes(button.name)) return;
      event.preventDefault();
      if (button.disabled) return;
      button.disabled = true;
      let message = form.querySelector('[data-blx-cart-message]');
      if (!message) {
        message = document.createElement('p');
        message.dataset.blxCartMessage = '';
        message.setAttribute('role', 'alert');
        message.style.gridColumn = '1 / -1';
        form.appendChild(message);
      }
      message.textContent = '';
      const adding = button.name === 'add';
      const payload = adding ? {items:[{id:form.elements.id.value,quantity:Number(form.elements.quantity.value)}]} : {updates:Array.from(form.querySelectorAll('input[name="updates[]"]'), input => Number(input.value))};
      const endpoint = adding ? new URL(form.action).pathname + '.js' : new URL(form.action).pathname.replace(/\/$/, '') + '/update.js';
      try {
        const cartPath = adding ? form.elements.return_to.value : new URL(form.action).pathname;
        const beforeResponse = await fetch(cartPath.replace(/\/$/, '') + '.js');
        if (!beforeResponse.ok) throw new Error('Cart unavailable');
        const beforeCart = await beforeResponse.json();
        const response = await fetch(endpoint, {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)});
        if (!response.ok) {
          // Shopify can cap an overstock request and return an error after changing the cart. Restore its prior state.
          const updates = {};
          if (adding) updates[form.elements.id.value] = beforeCart.items.filter(item => String(item.variant_id) === form.elements.id.value).reduce((sum, item) => sum + item.quantity, 0);
          else beforeCart.items.forEach(item => { updates[item.key] = item.quantity; });
          await fetch(cartPath.replace(/\/$/, '') + '/update.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates})});
          // Keep Shopify's stock quantity out of public copy.
          message.textContent = english ? 'This quantity is currently unavailable. Choose a smaller quantity.' : 'Dit aantal is momenteel niet beschikbaar. Kies een kleiner aantal.';
          return;
        }
        if (adding) window.location.assign(form.elements.return_to.value);
        else window.location.reload();
      } catch (_) {
        message.textContent = english ? 'Please try again to update your cart.' : 'Probeer opnieuw om je winkelwagen bij te werken.';
      } finally {
        button.disabled = false;
      }
    });
  });
})();
